import { SwiperSlide } from "swiper/react";
import AppSwiper from "../../common/AppSwiper";
import BrandCard from "./BrandCard";
import "./Brands.css";
import HomeContainer from "../HomeContainer/HomeContainer";
export default function Brands({ brands = [] }) {
  if (!brands.length) {
    return null;
  }

  return (
    <HomeContainer>
       <div class="homepage-section-title-wrapper"><span class="homepage-section-title-icon">✦</span>
       <div class="homepage-section-title-content"><h2 class="homepage-section-title">برندهای برتر  </h2></div></div>
      <section className="home-brands">
         
        <AppSwiper
          spaceBetween={10}
          navigation={false}
          breakpoints={{
            0: {
              slidesPerView: 2.2,
            },

            576: {
              slidesPerView: 3.2,
            },

            768: {
              slidesPerView: 4.2,
            },

            992: {
              slidesPerView: 7.2,
            },

            1200: {
              slidesPerView: 8,
            },
          }}
        >
          {brands.map((brand, index) => (
            <SwiperSlide key={brand.id}>
              <BrandCard key={brand.id} brand={brand} index={index} />
            </SwiperSlide>
          ))}
        </AppSwiper>
      </section>
    </HomeContainer>
  );
}
